import { useQueryClient } from '@tanstack/react-query';

import type { PrefetchContext, PrefetchedDataProps } from '#src/shared/prefetch';

import { prefetchStartAPetitionPageDataFromApi, useStartAPetitionPageDataFromApi } from './pageData';

export type StartAPetitionPagePrefetchedContext = Readonly<{
	pageData: Parameters<typeof useStartAPetitionPageDataFromApi>[0];
}>;

export type StartAPetitionPageCombinedState = ReturnType<typeof useStartAPetitionPageDataFromApi>;

export function usePageContext(prefetchedData?: StartAPetitionPagePrefetchedContext): StartAPetitionPageCombinedState {
	const queryClient = useQueryClient();

	return useStartAPetitionPageDataFromApi(prefetchedData?.pageData, queryClient);
}

export async function prefetchPageContext(context: PrefetchContext): Promise<StartAPetitionPagePrefetchedContext> {
	return { pageData: await prefetchStartAPetitionPageDataFromApi(context, context.queryClient) };
}

export type StartAPetitionPagePrefetchedDataProps = PrefetchedDataProps<StartAPetitionPagePrefetchedContext>;
